import * as ActionTypes from './actionTypes'



export const setNormalizedLanguage = (language, stateLocation) =>
{
    return {
        type: ActionTypes.SET_NORMALIZED_LANGUAGE,
        payload: {
            language,
            stateLocation
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/normalize-language/src/actions/actions.js